import { FunctionComponent } from 'react';
import { EmptyState, InvoicesDataRow, InvoicesEmptyTableCell } from './styled';

interface Props {
    message?: string;
}

const InvoicesTableEmptyRow: FunctionComponent<Props> = ({
    message = 'No invoices found'
}) => (
    <InvoicesDataRow>
        <InvoicesEmptyTableCell>
            <EmptyState>{message}</EmptyState>
        </InvoicesEmptyTableCell>
    </InvoicesDataRow>
);

export default InvoicesTableEmptyRow;
